import React from 'react';

import BaseModal from 'src/components/Modal/BaseModal';
import ContactForm from './ContactForm';

interface Props {
  fetchData: () => void,
  isOpen?: boolean,
  onClose: () => void,
}

function ContactModal({
  isOpen,
  onClose,
  fetchData,
}: Props) {
  const onSuccess = () => {
    fetchData();
    onClose();
  };

  return (
    <BaseModal
      onClose={onClose}
      title="Create contact"
      isOpen={isOpen}
    >
      <ContactForm
        onSuccess={onSuccess}
      />
    </BaseModal>
  );
}

ContactModal.defaultProps = {
  onCancel: () => {},
  open: false
};

export default ContactModal;
